<template>
  <div class="homslot-container" :class="[mode]">
    <!-- 문의하기 팝업 성공-->
    <AlertModalV2 v-if="isSuccessInquiry" @confirm-btn="isSuccessInquiry = false">
      <template #alertmodal-title>문의가 접수되었습니다.</template>
      <template #alertmodal-desc>빠른 시일 내에 답변드리겠습니다.</template>
    </AlertModalV2>
    <!-- 모바일웹 로그인 팝업 불가능 -->
    <AlertModalV2 v-if="isNotLoginMoModal" @confirm-btn="isNotLoginMoModal = false">
      <template #alertmodal-nontitle>
        PC웹 또는 앱에서만 가능합니다.
      </template>
    </AlertModalV2>
    <!--로그인 팝업 -->
    <SocialSignUpV2 v-if="isOpenSocialSignUp" :titleText="loginModalTitle" @close-socialsignup="isOpenSocialSignUp = false" />
    <!-- 문의하기 팝업 -->
    <ApInquiryModal
      v-if="isOpenInquiry"
      @close-modal="isOpenInquiry = false"
      @complete-inquiry="[(isOpenInquiry = false), (isSuccessInquiry = true)]"
    />
    <!-- 헤더 -->
    <header class="homeheader" ref="homeHeader" :class="[mode]">
      <!-- PC Header -->
      <nav class="homeheader-nav">
        <ul class="homeheader-menulist">
          <!-- 좌측 메뉴 -->
          <li class="homeheader-leftmenu">
            <router-link :to="{ path: '/home' }">
              <!-- -->
              <img class="logo-img" src="/media/images/logo/aplayz-logo-home-red.png" alt="logo" />
            </router-link>
            <ul class="service-menulist">
              <li>
                <router-link class="service-menuitem" :class="[mode]" :to="{ path: '/introduce' }">
                  서비스 소개
                </router-link>
              </li>

              <li>
                <router-link
                  class="service-menuitem"
                  :class="[mode, routeName === 'RatePlanView' ? 'active' : '']"
                  :to="{ path: '/rateplan' }"
                >
                  요금제
                </router-link>
              </li>
              <li class="relative">
                <a
                  class="service-menuitem"
                  @click="isOpenSubMenu = !isOpenSubMenu"
                  :class="[mode, routeName === 'PreView' || routeName === 'AiChannelPreview' ? 'active' : '']"
                  tabindex="0"
                >
                  미리보기
                </a>

                <ul v-if="isOpenSubMenu" class="sub-menulist cursor" :class="[mode]" v-click-outside="outSideClick">
                  <li>
                    <a
                      class="sub-menuitem"
                      :class="[mode]"
                      @click="handleSubMenuClick('/aichannelpreview')"
                    >
                      AI 채널
                    </a>
                  </li>
                  <li>
                    <a
                      class="sub-menuitem last"
                      :class="[mode]"
                      @click="handleSubMenuClick('/preview')"
                    >
                      MY 채널
                    </a>
                  </li>
                </ul>
              </li>
            </ul>
          </li>
          <!-- 우측 메뉴 -->
          <li class="right-menu">
            <a
              class="right-btn inquiry"
              :class="[mode]"
              tabindex="0"
              @keydown.enter.prevent="isOpenInquiry = true"
              @click="isOpenInquiry = true"
              >문의</a
            >
            <a
              class="right-btn login"
              tabindex="0"
              @keydown.enter.prevent="isOpenSocialSignUp = true"
              @click="onClickLogin"
              >로그인</a
            >
          </li>
        </ul>
      </nav>
      <!-- Mobile Header -->
      <nav class="homeheader-navmo">
        <ul class="homeheader-momenu">
          <!-- mobile-leftmenu-->
          <li class="homeheader-moleftmeun">
            <a
              tabindex="0"
              class="hambuger-mo-menu"
              @click="[(isOpenMobileMenu = !isOpenMobileMenu), (isOpenMobileSubMenu = false)]"
            >
              <img
                class="hambuger-mo-menu"
                :src="
                  mode === 'white'
                    ? '/media/images/icon/hambuger-black-icon.png'
                    : '/media/images/icon/hambuger-white-icon.png'
                "
                alt="hambuger-white-icon.png"
              />
            </a>

            <router-link tabindex="0" class="hambuger-mo-logo" :to="{ path: '/home' }">
              <img
                class="hambuger-mo-logo"
                src="/media/images/logo/aplayz-logo-red.png"
                alt="hambuger-white-icon.png"
              />
            </router-link>
          </li>

          <!-- mobile-rightmenu-->
          <li class="homeheader-morightmenu">
            <a tabindex="0" class="login-mobtn" @click="isOpenSocialSignUp = true">로그인</a>
          </li>
        </ul>
      </nav>

      <!-- Mobile Menu list -->
      <div class="mobile-menulistwrap" v-if="isOpenMobileMenu">
        <ul class="mobile-menulist" :class="[mode]">
          <li class="mobile-menuitem">
            <router-link
              class="menu-link"
              :class="[mode]"
              :to="{ path: '/introduce' }"
              tabindex="0"
              @click.native="handleClickIntroduce"
              >서비스 소개</router-link
            >
          </li>
          <li class="mobile-menuitem">
            <router-link
              class="menu-link"
              :class="[mode]"
              :to="{ path: '/rateplan' }"
              @click.native="handleClickIntroduce"
              tabindex="0"
              >요금제</router-link
            >
          </li>
          <li class="mobile-menuitem">
            <a
              class="menu-link"
              tabindex="0"
              :class="[mode]"
              @click="[(isOpenMobileMenu = false), (isOpenInquiry = true)]"
              >문의</a
            >
          </li>
        </ul>
        <div class="black-dim" @click="isOpenMobileMenu = false"></div>
      </div>
    </header>
    <!-- 메인 -->
    <main class="home-main" :class="isheightauto ? 'hauto' : ''">
      <slot name="home-main"></slot>
    </main>
    <!-- 푸터 -->
    <footer class="home-footer" :class="footercolor" v-if="isshowfooter">
      <div class="main2-footer">
        <div class="main2-footer-companyinfo-wrap">
          <div class="main2-footer-companyinfo">
            <div
              class="companyinfo-text"
              :class="footercolor"
              tabindex="0"
              @click="goOtherPage(`https://corp.aplayz.co.kr/`)"
            >
              회사 소개
              <img
                class="arrow-outward-icon"
                :class="footercolor"
                src="/media/images/icon/arrow-outward-white-icon.png"
                alt="arrow-outward-icon.png"
              />
            </div>
            <div
              class="companyinfo-text"
              tabindex="0"
              :class="footercolor"
              @click="goOtherPage(`https://corp.aplayz.co.kr/product/personal`)"
            >
              래디오
              <img
                class="arrow-outward-icon"
                src="/media/images/icon/arrow-outward-white-icon.png"
                alt="arrow-outward-icon.png"
              />
            </div>
            <div
              class="companyinfo-text"
              :class="footercolor"
              tabindex="0"
              @click="goOtherPage(`https://brand.aplayz.co.kr/`)"
            >
              프랜차이즈
              <img
                class="arrow-outward-icon"
                src="/media/images/icon/arrow-outward-white-icon.png"
                alt="arrow-outward-icon.png"
              />
            </div>
            <div class="companyinfo-text" :class="footercolor" tabindex="0" @click="goInnerPage(`/agree/service`)">
              서비스 이용약관
            </div>
            <div class="companyinfo-text" :class="footercolor" @click="goInnerPage(`/agree/privacy`)">
              개인정보처리방침
            </div>
          </div>
          <div class="main2-footer-sns pc">
            <div class="sns-wrap cursor" @click="goOtherPage(`https://www.instagram.com/aplayz_official`)">
              <img class="instgram-icon" src="/media/images/icon/instgram-icon.png" alt="인스타그램" />
            </div>
            <div class="sns-wrap cursor" @click="goOtherPage(`https://www.youtube.com/@aplayz_official`)">
              <img class="youtube-icon" src="/media/images/icon/youtube-icon.png" alt="유투브" />
            </div>
            <div class="sns-wrap cursor" @click="goOtherPage(`https://blog.naver.com/aplayz_official`)">
              <img class="blog-icon" src="/media/images/icon/blog-icon.png" alt="블로그" />
            </div>
          </div>
        </div>
        <div class="companyinfo-detail" :class="footercolor">
          <div class="companyinfo-detail1">
            상호명 : (주)어플레이즈 &nbsp; 대표 : 배정진 &nbsp; 사업장 소재지 : 서울특별시 강남구 도산대로 15길 12, 3층
            &nbsp; 사업자 등록번호 : 756-86-02541 &nbsp; 통신판매업신고번호 : 2024-서울강남-06965 &nbsp;<a
              tabindex="0"
              class="cursor business-info"
              @click="goOtherPage(`https://www.ftc.go.kr/bizCommPop.do?wrkr_no=7568602541`)"
            >
              사업자 정보확인
            </a>
          </div>
          <div class="companyinfo-detail2">
            문의 : contact@aplayz.co.kr &nbsp;고객센터 : 070-4060-8362
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>
<script>
import vClickOutside from 'v-click-outside';
import ApInquiryModal from '../components/modal/Inquiry/ApInquiryModal.vue';
import SocialSignUpV2 from '../components/join/SocialSignUpV2.vue';
import AlertModalV2 from '../components/modal/AlertModalV2.vue';
import { getMobileOS } from '../utils/Utils';
export default {
  props: {
    mode: {
      type: String,
      default: 'white',
      required: false
    },
    footercolor: {
      type: String,
      default: null,
      required: false
    },
    isshowfooter: {
      type: Boolean,
      default: true,
      required: false
    },
    isheightauto: {
      type: Boolean,
      default: true,
      required: false
    },
    loginModalTitle: {
      type: String,
      default: '지금 로그인하고, <br />나를 위한 채널에 입장해보세요.',
      required: false
    }
  },
  directives: {
    clickOutside: vClickOutside.directive
  },
  components: {
    SocialSignUpV2,
    ApInquiryModal,
    AlertModalV2
  },
  data() {
    return {
      isOpenSubMenu: false,
      isOpenSocialSignUp: false,
      isOpenInquiry: false,
      isSuccessInquiry: false,
      isOpenMobileSubMenu: false,
      isOpenMobileMenu: false,
      isNotLoginMoModal: false,
      startY: 0,
      currentY: 0,
      isPointerDown: false
    };
  },
  created() {
    if (this.$cookies.get('autoLogin') === 'Y') {
      // main 화면 이동
      this.$router.push({ path: '/main' });
    }
  },
  methods: {
    onClickOpenLogin() {
      if (getMobileOS() === 'Android' || getMobileOS() === 'iOS') {
        this.isNotLoginMoModal = true;
      } else {
        this.isOpenSocialSignUp = true;
      }
    },
    goOtherPage(url) {
      window.open(url, '_blank');
    },
    goInnerPage(pathUrl) {
      this.$router.push({ path: pathUrl });
    },
    handleClickIntroduce() {
      this.isOpenMobileMenu = false;
    },
    onClickLogin() {
      this.$router.push({ path: '/login' });
    },
    outSideClick() {
      this.isOpenSubMenu = false;
    },
    handleSubMenuClick(targetPath) {
      // 메뉴 닫기
      this.isOpenSubMenu = false;

      // 현재 라우트와 다른 경우에만 라우팅
      if (this.$route.path !== targetPath) {
        this.$router.push({ path: targetPath });
      }
    },
    getHomeHeader() {
      return this.$refs.homeHeader;
    },
    handlePointerDown(e) {
      if (e.pointerType !== 'touch' && e.pointerType !== 'mouse') return;
      this.isPointerDown = true;
      this.startY = e.clientY;
    },
    handlePointerMove(e) {
      if (!this.isPointerDown) return;

      this.currentY = e.clientY;
      const deltaY = this.currentY - this.startY;

      if (Math.abs(deltaY) > 5) {
        window.scrollBy({
          top: -deltaY,
          behavior: 'auto'
        });
        this.startY = this.currentY;
      }
    },
    handlePointerUp(e) {
      if (!this.isPointerDown) return;
      this.isPointerDown = false;

      // 예: 아래 방향 스크롤 후 손 뗐을 때 특정 동작
      if (this.currentY - this.startY > 30) {
        console.log('아래로 드래그 후 손을 뗐습니다.');
      }
    }
  },
  mounted() {
    // document.querySelector('.app').style.height = 'auto';
    /* 설치형 프로그램 PointerEvent */
    if (navigator.userAgent.includes('APLAYZ PoS')) {
      window.addEventListener('pointerdown', this.handlePointerDown);
      window.addEventListener('pointermove', this.handlePointerMove);
      window.addEventListener('pointerup', this.handlePointerUp);
      window.addEventListener('pointercancel', this.handlePointerUp);
    }
  },
  beforeDestroy() {
    // document.querySelector('.app').style.height = null;
    if (navigator.userAgent.includes('APLAYZ PoS')) {
      window.removeEventListener('pointerdown', this.handlePointerDown);
      window.removeEventListener('pointermove', this.handlePointerMove);
      window.removeEventListener('pointerup', this.handlePointerUp);
      window.removeEventListener('pointercancel', this.handlePointerUp);
    }
  },
  computed: {
    routeName() {
      return this.$route.name;
    }
  }
};
</script>
<style scoped src="@/assets/css/homeslot/homeslot.css"></style>
